export const SUPPORT = {
  SEND_MESSAGE: 'SEND_MESSAGE'
};
